import DragScroll from './DragScroll';
import * as Helper from "../utils/helpers";
import DafMark from "./daf-mark";

export default class MyAccount {
    constructor() {
        this.addEvents();
        this.wordLimit();

        this.loadMoreBtn = document.querySelectorAll('.load-more-btn');

        if(this.loadMoreBtn.length) {
            this.loadMore();
        }

    }

    addEvents() {
        // Initialize drag scroll for maintabs wrappers
        new DragScroll('.myAccount__maintabs__wrapper');

        // Initialize drag scroll for all subtabs
        new DragScroll('.myAccount__subtabs--left');

        new DragScroll('.floating-cpt__head--left');

        var english = /^[a-zA-Z0-9;,.!@#$%:{}[]?"^&*()']*|[^&;<>`]*$/;

        let removedElement;

        if ($('section').hasClass('myAccount')) {
            $('body').addClass('body-account');
            let params = new URL(window.location.href).searchParams;
            let subTab = params.get('subtab');
            let masechet = $('.myAccount__list .myAccount__list--maintab:nth-child(4) .myAccount__list--subtab:nth-child(1)');

            setTimeout(()=> {
                if ($('.myAccount__list--maintab:nth-child(2) .search__item').length == 0) {
                    $('.myAccount__subtab:nth-child(2) .myAccount__subtab--item:first-child').click();
                }

                if ($('.myAccount__list--maintab:nth-child(3) .search__item').length == 0) {
                    $('.myAccount__subtab:nth-child(3) .myAccount__subtab--item:first-child').click();
                }
            }, 100);

            if(params.get('tab')){
                setTimeout(()=>{
                    $('.myAccount__maintab[data-tab="'+params.get('tab')+'"]').click();
                    if(subTab){
                        setTimeout(()=>{
                            $('.myAccount__subtab.active .myAccount__subtab--item:nth-child('+subTab+')').click();
                        }, 100)
                        if(masechet.find('.search__item').length > 0){
                            masechet.addClass('active');
                            $('.myAccount__subtab:nth-child(4) .myAccount__subtab--item').removeClass('active');
                            $('.myAccount__subtab:nth-child(4) .myAccount__subtab--item:nth-child(2)').addClass('active');
                        }
                    }
                }, 100)
            }
        }

        $('.myAccount__notification--checkbox').on('click', function (e){
            $(this).toggleClass('active');
            $('.myAccount__notification--buttons>div').removeClass('disabled');
        })

        $('.myAccount__notification--buttons>div').on('click', function (e){
            var ajaxurl = myAjax.ajaxurl;
            let daf =  $('.myAccount__notification--cpt[data-tax="daf"] .myAccount__notification--checkbox[data-type="push"]');
            let dafMailchimp =  $('.myAccount__notification--cpt[data-tax="daf"] .myAccount__notification--checkbox[data-type="email"]');
            let beyong =  $('.myAccount__notification--cpt[data-tax="beyond-the-daf"] .myAccount__notification--checkbox[data-type="push"]');
            let beyongMailchimp =  $('.myAccount__notification--cpt[data-tax="beyond-the-daf"] .myAccount__notification--checkbox[data-type="email"]');
            let course =  $('.myAccount__notification--cpt[data-tax="sfwd-courses"] .myAccount__notification--checkbox[data-type="push"]');
            let courseMailchimp =  $('.myAccount__notification--cpt[data-tax="sfwd-courses"] .myAccount__notification--checkbox[data-type="email"]');
            let masechet =  $('.myAccount__notification--cpt[data-tax="masechet"] .myAccount__notification--checkbox[data-type="push"]');
            let masechetMailchimp =  $('.myAccount__notification--cpt[data-tax="masechet"] .myAccount__notification--checkbox[data-type="email"]');
            let authors =  $('.myAccount__notification--cpt[data-tax="authors"] .myAccount__notification--checkbox[data-type="push"]');
            let authorsMailchimp =  $('.myAccount__notification--cpt[data-tax="authors"] .myAccount__notification--checkbox[data-type="email"]');

            $.ajax({
                type: "POST",
                url: ajaxurl,
                data: {
                    "action": 'notification_update',
                    'nt-daf': daf.hasClass('active') ? 1 : 0,
                    'mt-daf': dafMailchimp.hasClass('active') ? 1 : 0,
                    'nt-beyong': beyong.hasClass('active') ? 1 : 0,
                    'mt-beyong': beyongMailchimp.hasClass('active') ? 1 : 0,
                    'nt-course': course.hasClass('active') ? 1 : 0,
                    'mt-course': courseMailchimp.hasClass('active') ? 1 : 0,
                    'nt-masechet': masechet.hasClass('active') ? 1 : 0,
                    'mt-masechet': masechetMailchimp.hasClass('active') ? 1 : 0,
                    'nt-authors': authors.hasClass('active') ? 1 : 0,
                    'mt-authors': authorsMailchimp.hasClass('active') ? 1 : 0,
                    'lang': $('html').attr('lang') != 'en-US' ? '_he' : ''
                },
                success: function (result) {
                    $('.myAccount__notification--buttons>div').addClass('disabled');
                }
            });
        })

        $('.myAccount__checkbox div').on('click', function (e) {
            $(this).hasClass('active') ? $(this).removeClass('active') : $(this).addClass('active');
        });

        $('.myAccount__pass svg, .myAccount__passrepeat svg').on('click', function (e) {
            let input = $(this).parents('.myAccount__input').find('input');
            if (input.attr('type') == 'text') {
                input.attr('type', 'password');
            } else {
                input.attr('type', 'text');
            }
        });

        $('.myAccount__popup .rgba, .myAccount__popup .myAccount__popup--buttons div:nth-child(1)').on('click', function (e) {
            e.preventDefault();
            $('.myAccount__popup').removeClass('active');
        })

        $('.myAccount__clear, .floating-cpt__removeAll').on('click', function (e) {
            e.preventDefault();
            $('.removeAll').addClass('active')
        })

        $('.myAccount__photo--change').on('click', function (e) {
            e.preventDefault();
            $('input[type=file][data-ajaxed=Y]').click();
            $('.myAccount__buttons div.disabled').removeClass('disabled');
        })

        $('.myAccount__buttons div:nth-child(1)').on('click', function (e) {
            e.preventDefault();
            let error = 0;
            let pass = $('.myAccount__input--password');
            let passnew = $('.myAccount__input--passrepeat');
            let username = $('.myAccount__input--username');
            let firstname = $('.myAccount__input--firstname');
            let lastname = $('.myAccount__input--lastname');

            if (english.test(username.val()) && username.val().length >= 2) {
                username.removeClass('error');
            } else {
                username.addClass('error');
                error++;
            }

            if (firstname.val().length >= 2) {
                firstname.removeClass('error');
            } else {
                firstname.addClass('error');
                error++;
            }

            if (lastname.val().length >= 2) {
                lastname.removeClass('error');
            } else {
                lastname.addClass('error');
                error++;
            }

            if (pass.val().length >= 1) {
                if (pass.val().length >= 6) {
                    pass.removeClass('error');
                } else {
                    pass.addClass('error');
                    error++;
                }

                if (passnew.val().length >= 6) {
                    passnew.removeClass('error');
                } else {
                    passnew.addClass('error');
                    error++;
                }
            }


            if (error == 0) {
                var ajaxurl = myAjax.ajaxurl;
                jQuery.ajax({
                    type: 'POST',
                    url: ajaxurl,
                    data: {
                        "action": "ajax_update_user",
                        password: pass.val(),
                        passnew: passnew.val(),
                        username: username.val(),
                        firstname: firstname.val(),
                        lastname: lastname.val(),
                        check: $('.myAccount__checkbox div').hasClass('active') ? 1 : 0
                    },
                    success: function (response) {
                        let resp = JSON.parse(response);
                        if (resp.username) {
                            username.addClass('error');
                        } else {
                            username.remove('error');
                        }

                        if (resp.pass) {
                            pass.addClass('error');
                        } else {
                            pass.remove('error');
                        }

                        window.location.reload();

                    }
                });
            }


        })


        $('input[type=file][data-ajaxed=Y]').on('change', function (event) {

            let files = event.target.files;
            var name = $(this).attr('name');

            var data = new FormData();
            $.each(files, function (key, value) {
                data.append(key, value);
            });

            data.append('type', $(this).data('type'));
            let ajax_url = myAjax.ajaxurl;

            $.ajax({
                url: ajax_url + '?action=file_upload&fname=' + name,
                type: "POST",
                data: data,
                dataType: 'json',
                contentType: false,
                cache: false,
                processData: false,
                success: function (data) {
                    $('.myAccount__photo img').attr('src', data.src);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log('ERRORS: ' + textStatus);
                }
            });
        });

        $('.myAccount__maintab').on('click', function (e) {
            let inx = $(this).index() + 1;
            $('.myAccount__maintab, .myAccount__subtab, .myAccount__list--maintab').removeClass('active');
            $(this).addClass('active');
            $('.myAccount__subtab:nth-child(' + inx + ')').addClass('active');
            $('.myAccount__list--maintab:nth-child(' + inx + ')').addClass('active');

            // Scroll active elements into view
            const mainTab = $(this)[0];
            const subTab = $('.myAccount__subtab:nth-child(' + inx + ')')[0];

            if (mainTab) {
                mainTab.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
            if (subTab) {
                subTab.scrollIntoView({behavior: 'smooth', block: 'center'});
            }

            if ($('.myAccount__subtab:nth-child(' + inx + ') .myAccount__subtab--item.active').attr('data-start') == 'true') {
                $('.myAccount__start').removeClass('hide');
                $('.myAccount__list').addClass('hide');
            } else {
                $('.myAccount__start').addClass('hide');
                $('.myAccount__list').removeClass('hide');
            }

            inx == 1 ? $('.myAccount__maintab--calendar').addClass('hide') : $('.myAccount__maintab--calendar').removeClass('hide');

            generateSaveLink();

        });

        function generateSaveLink(){
            let tabName = $('.myAccount__maintab.active').attr('data-tab');
            let active_subtab = $('.myAccount__subtab.active .myAccount__subtab--item.active').index() + 1;
            window.history.pushState('', '', window.location.origin+window.location.pathname+"?tab="+tabName+'&subtab='+active_subtab);
        }

        $('.myAccount__subtab--item').on('click', function (e) {
            e.preventDefault();
            console.log(44545454);
            let inx = $(this).index() + 1;
            $(this).parents('.myAccount__subtab').find('.myAccount__subtab--item').removeClass('active');
            $('.myAccount__list--maintab.active .myAccount__list--subtab').removeClass('active');
            $(this).addClass('active');
            if ($(this).attr('data-start') == 'true') {
                $('.myAccount__start').removeClass('hide');
                $('.myAccount__list').addClass('hide');
            } else {
                $('.myAccount__start').addClass('hide');
                $('.myAccount__list').removeClass('hide');
                if ($(this).parents('.myAccount__subtabs--left').find('.myAccount__subtab--item[data-start="true"]').length > 0) {
                    inx--;
                }
                $('.myAccount__list--maintab.active .myAccount__list--subtab:nth-child(' + inx + ')').addClass('active');
            }

            // Scroll active elements into view
            const subTabItem = $(this)[0];
            const subTab = $('.myAccount__list--maintab.active .myAccount__list--subtab:nth-child(' + inx + ')')[0];

            if (subTabItem && !$(subTabItem).parents('.myAccount').length) {
                subTabItem.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
            if (subTab && !$(subTab).parents('.myAccount').length) {
                subTab.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
            generateSaveLink();
        })

        $('.myAccount__subtabs--search input').on('input', function (e) {
            let search = $(this).val().toLowerCase();
            $('.myAccount__list--maintab.active .myAccount__list--subtab').each(function (i, e) {
                let parentList = $(this);
                if (parentList.find('.search__item').length > 0) {
                    parentList.find('.search__item').each(function (i, e) {
                        let title = $(this).find('.search__item--title').text().toLowerCase();
                        let excerpt = $(this).find('.search__item--excerpt').text().toLowerCase();
                        if (title.indexOf(search) == -1 && excerpt.indexOf(search) == -1) {
                            $(this).addClass('hide');
                        } else {
                            $(this).removeClass('hide');
                        }
                    })
                }

                if (search.length == 0) {
                    parentList.find('.search__item').removeClass('hide');
                }

                parentList.find('.myAccount__top>span i').html(parentList.find('.search__item:not(.hide)').length);
            })

            $('.floating-cpt__item.active').each(function (i, e) {
                let parentList = $(this);
                if (parentList.find('.search__item').length > 0) {
                    parentList.find('.search__item').each(function (i, e) {
                        let title = $(this).find('.search__item--title').text().toLowerCase();
                        let excerpt = $(this).find('.search__item--excerpt').text().toLowerCase();
                        if (title.indexOf(search) == -1 && excerpt.indexOf(search) == -1) {
                            $(this).addClass('hide');
                        } else {
                            $(this).removeClass('hide');
                        }
                    })
                }

                if (search.length == 0) {
                    parentList.find('.search__item').removeClass('hide');
                }
            })
        })

        $('.myAccountSort').on('click', function (e) {
            let current = $(this).text();
            let sortParent = $('.myAccount__list--maintab.active .myAccount__list--subtab.active');
            let sortContainer = $('.myAccount__list--maintab.active .myAccount__list--subtab.active .results');

            if (current == 'Most Recent') {
                sortParent.find('.search__item').sort((a, b) => $(b).data("time") - $(a).data("time")).appendTo(sortContainer);
            } else if (current == 'Oldest') {
                sortParent.find('.search__item').sort((a, b) => $(a).data("time") - $(b).data("time")).appendTo(sortContainer);
            } else if (current == 'Title A-Z') {
                sortParent.find('.search__item').detach().sort(function (a, b) {
                    return $(a).find(".search__item--title").text().localeCompare($(b).find(".search__item--title").text());
                }).appendTo(sortContainer);
            } else if (current == 'Title Z-A') {
                sortParent.find('.search__item').detach().sort(function (a, b) {
                    return $(b).find(".search__item--title").text().localeCompare($(a).find(".search__item--title").text());
                }).appendTo(sortContainer);
            }
        })

        $('.removeAll .myAccount__popup--buttons div:nth-child(2)').on('click', function (e) {
            e.preventDefault();
            var ajaxurl = myAjax.ajaxurl;
            let ids = [];
            let tab = '';
            let subtab = '';
            if($('.myAccount__maintab').hasClass('active')){
                $('.myAccount__list--maintab.active .myAccount__list--subtab.active .search__item').each(function (i,e){
                    ids.push($(this).attr('data-id'));
                })
                tab = $('.myAccount__maintab.active').attr('data-tab');
                subtab = $('.myAccount__subtab.active .myAccount__subtab--item.active').attr('data-subtab');
            }else{
                $('.floating-cpt__item.active .floating-cpt__content--item.active .search__item').each(function (i,e){
                    ids.push($(this).attr('data-id'));
                })
                tab = $('.floating-bar__list .active').attr('data-tab');
                subtab = $('.floating-cpt__item.active .floating-cpt__subitem.active').attr('data-subtab');
            }

            jQuery.ajax({
                type: 'POST',
                url: ajaxurl,
                data: {
                    "action": "remove_learning",
                    'ids': ids.join(','),
                    'tab' : tab,
                    'subtab' : subtab
                },
                success: function (response) {
                    window.location.reload();
                }
            });
        });


        $('.myAccount__list--subtab, .floating-cpt__content--item').on('click', '.search__item--buttons .search__item--bookmark, .search__item--trash-can', function (e){
            let id_page = $(this).attr("data-id");
            $('.removeSingle').addClass('active').attr('data-id', id_page).attr('data-type', '1');
            removedElement = $(this).parents('.search__item');
            e.preventDefault();
        })

        $('.myAccount__list--subtab,.floating-cpt__content--item').on('click', '.search__item--buttons .search__item--checkmark', function (e) {
            let id_page = $(this).attr("data-id");

            e.preventDefault();
            if ($(this).hasClass('active')) {
                $('.removeSingle').addClass('active').attr('data-id', id_page).attr('data-type', '2');
                removedElement = $(this).parents('.search__item');
            }else{
                let btn = $(this);
                var ajaxurl = myAjax.ajaxurl;
                jQuery.ajax({
                    type: "POST",
                    url: ajaxurl,
                    data: {
                        "action": "mark_as_complete_ajax",
                        'id_page': id_page,
                        'remove' : 'no'
                    },
                    success: function (result) {
                        if(result == 'added') {
                            btn.addClass('active');
                        }else{
                            btn.removeClass('active');
                        }
                    }
                });
            }
        })

        function getPushEngageId() {
            return new Promise((resolve, reject) => {
                PushEngage.push(function () {
                    PushEngage.getSubscriberId()
                        .then(function (subscriberId) {
                            resolve(subscriberId);
                        })
                        .catch(function (err) {
                            resolve('');
                        });
                });
            });
        }

        $('.removeSingle').on('click', '.myAccount__popup--buttons>div:nth-child(2)', function (e) {
            e.preventDefault();
            let id = $('.removeSingle').attr('data-id');
            var ajaxurl = myAjax.ajaxurl;
            let action = 'follow_ajax';
            if ($('.removeSingle').attr('data-type') == '2') {
                action = 'mark_as_complete_ajax';
            }
           
            getPushEngageId().then(profilePush => {
                $.ajax({
                    type: "POST",
                    url: ajaxurl,
                    data: {
                        "action": action,
                        'id_page': id,
                        'remove': 'yes',
                        'profile_id': profilePush,
                        'author_page': 'yes',
                        'lang': $('html').attr('lang') != 'en-US' ? '_he' : ''
                    },
                    success: function (result) {
                        removedElement.remove();
                        $('.search__item[data-id="' + id + '"]').remove();
                        let counter = $('.myAccount__list--maintab.active .myAccount__list--subtab.active .myAccount__top span i');
                        counter.html(parseInt(counter.html()) - 1);
                        $('.removeSingle').removeClass('active');
                    }
                });
            });
        });

        $('.search__item--view-courses.closed').on('click', function () {
            const search_item = $(this).parents('.search__item');
            search_item.find('.search__item--courses').show();
            search_item.find('.search__item--view-courses.opened').show();
            search_item.find('.search__item--view-courses.closed').hide();
        })

        $('.search__item--view-courses.opened').on('click', function () {
            const search_item = $(this).parents('.search__item');
            search_item.find('.search__item--view-courses.closed').show()
            search_item.find('.search__item--view-courses.opened').hide()
            search_item.find('.search__item--courses').hide();
        })

    }

    wordLimit() {
        let wordLimit = 21;

        $(".search__item--desc").each(function () {
            let words = $(this).text().trim().split(/\s+/);
            if (words.length > wordLimit) {
                $(this).text(words.slice(0, wordLimit).join(" ") + "...");
            }
        });
    }

    loadMore() {
        $('.load-more-btn').on('click', function() {
            const btn = $(this);
            let type = btn.data('type');
            let results_class = '.beyond-daf__results';
            let ajax_data = {};
            let offset = '';
            if (btn.data('loading') === true) return;
            if(type === 'beyond_the_daf'){
                let termIds = btn.data('term_ids') || [];
                let offsetIds = btn.data('offset_ids') || [];

                ajax_data = {
                    action: 'load_more_beyond_daf',
                    offset: offset,
                    'term_ids[]': termIds,
                    'offset_ids[]': offsetIds
                }
            }else if(type == 'beyond_the_daf-complete'){
                let termIds = btn.data('term_ids') || [];
                let offsetIds = btn.data('offset_ids') || [];

                ajax_data = {
                    action: 'load_more_beyond_daf_complete',
                    offset: offset,
                    'term_ids[]': termIds,
                    'offset_ids[]': offsetIds
                }
            } else if(type === 'daf'){
                results_class = '.daf__results';
                let where_ids = btn.data('where_ids') || [];

                ajax_data = {
                    action: 'load_more_daf',
                    offset: offset,
                    'where_ids[]': where_ids,
                }
            }else if(type === 'sfwd-courses'){
                results_class = '.sfwd-courses__results';
                let where_ids = btn.data('where_ids') || [];

                ajax_data = {
                    action: 'load_more_sfwd_courses',
                    offset: offset,
                    'where_ids[]': where_ids,
                }
            } else if(type === 'recently'){
                results_class = '.recently__results';
                let post_ids = btn.data('post_ids') || [];

                ajax_data = {
                    action: 'load_more_recently',
                    offset: offset,
                    post_ids: post_ids
                }

            }else if(type === 'suggested'){
                results_class = '.suggested__results';
                let exclude_ids = btn.data('exclude_ids') || [];
                let post_types = btn.data('post_types') || [];
                let post_lang = btn.data('post_lang') || [];
                let term_ids = btn.data('term_ids') || [];

                ajax_data = {
                    action: 'load_more_suggested',
                    offset: offset,
                    'exclude_ids[]': exclude_ids,
                    'post_types[]': post_types,
                    'term_ids[]': term_ids,
                }

            }else if(type === 'courses'){
                results_class = '.courses__results';
                let where_ids = btn.data('where_ids') || [];
                let course_data = btn.data('course_data') || [];

                ajax_data = {
                    action: 'load_more_courses',
                    offset: offset,
                    'where_ids': where_ids,
                    'course_data': course_data,
                    next: btn.data('next')
                }

            } else if (type === 'authors') {
                results_class = '.authors__results';
                let ids = btn.data('ids') || [];

                ajax_data = {
                    action: 'load_more_authors',
                    ids: ids,
                    offset: offset,
                    limit: 10
                };
            } else if (type === 'masechet') {
                results_class = '.masechet__results';
                let completed = btn.data('completed');

                ajax_data = {
                    action: 'load_more_masechet',
                    offset: offset,
                    completed: completed === true || completed === 'true',
                    next: btn.data('next')
                };
            }

            let container = $(this).parent().find(results_class);
            btn.data('loading', true).text('Loading...');
            let ajaxurl = myAjax.ajaxurl;
            offset = parseInt(container.data('offset'));
            let total = parseInt(container.data('total'));

            ajax_data.offset = offset;

            $.ajax({
                url: ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: ajax_data,
                success: function(response) {
                    if (response.success && response.data.html) {
                        container.append(response.data.html);
                        container.data('offset', offset + 10);
                        let result = container.parents('.myAccount__list--subtab.active').find('.myAccount__top i');
                        let search = container.parents('.myAccount__right').find('.myAccount__subtab.active .myAccount__subtabs--search input');

                        if($('.myAccount__list--maintab.active').index() != 4){
                            $(container.parents('.myAccount__list--subtab.active').find('.myAccountSort.active')[0]).trigger('click');
                        }
                        $('.post-paginate__sort.open').removeClass('open');

                        result.each(function () {
                            if(offset + 10 < total) {
                                $(this).text(offset + 10)
                            } else {
                                $(this).text(total)
                            }
                        })

                        search.each(function () {
                            $(this).val('')
                            $(this).trigger('input')
                        })

                        if ((offset + 10) >= total) {
                            btn.hide();
                        } else {
                            btn.data('loading', false).text('Load More');
                        }

                        $('.animation-container svg').each(function () {
                            $(this).remove();
                        })

                        Helper.setAnimatedIcon(true);
                        new DafMark();

                        $('.search__item--view-courses.closed').off().on('click', function () {
                            const search_item = $(this).parents('.search__item');
                            search_item.find('.search__item--courses').show();
                            search_item.find('.search__item--view-courses.opened').show();
                            search_item.find('.search__item--view-courses.closed').hide();
                        })

                        $('.search__item--view-courses.opened').off().on('click', function () {
                            const search_item = $(this).parents('.search__item');
                            search_item.find('.search__item--view-courses.closed').show()
                            search_item.find('.search__item--view-courses.opened').hide()
                            search_item.find('.search__item--courses').hide();
                        })

                    } else {
                        btn.text('No More Posts');
                    }
                },
                error: function() {
                    btn.data('loading', false).text('Load More');
                    alert('Something went wrong. Please try again.');
                }
            });
        });
    }
}